var modules_4fe38840 = {"container":"SliderInput_module_container__c38a9ea5","slider":"SliderInput_module_slider__c38a9ea5"};
import "../../../assets/esm/components/SliderInput/src/SliderInput~DiBSxm6s.css";

export { modules_4fe38840 as default };
//# sourceMappingURL=SliderInput.module.less.js.map
